// Querys and Mutations
import {
    ALL_ACTIVE,
    CHANGE_STATUS,
    CREATE,
    UPDATE,
    GET_WITH_PAGINATION,
    DELETE
} from '@/graphql/config/ReasonForPermissionGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { ReasonForPermissionModel, ReasonForPermissionForm, ReasonForPermissionWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class ReasonForPermissionService {
    /**
     * Queries
     */
    async getActivated (): Promise<ReasonForPermissionModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.reaonsForPermissionActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<ReasonForPermissionWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.reaonsForPermissionWithPagination.paginatorInfo
        const data: [ReasonForPermissionModel] = result.data.reaonsForPermissionWithPagination.data
        const response: ReasonForPermissionWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: ReasonForPermissionForm): Promise<ReasonForPermissionModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createReasonForPermission
    }

    async update (id: number, form: ReasonForPermissionForm): Promise<ReasonForPermissionModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateReasonForPermission
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new ReasonForPermissionService()
